<template>
  <div
    class="reviews-empty d-flex flex-column align-center"
    data-qa="lpu_reviews_empty"
  >
    <img
      :alt="tStatic('Отзывов нет')"
      class="mb-4"
      width="175"
      height="148"
      src="/static/_v1/pd/pictures/reviews-list/empty-reviews.svg"
      draggable="false"
    >
    <div
      class="reviews-empty__text text-body-1 text--text text-center"
      :class="{ 'reviews-empty__text--mobile': isMobile }"
    >
      {{ tStatic('Еще нет отзывов') }}
      {{ tStatic('о клинике') }}
      <span class="text-subtitle-1">{{ lpuName }}</span>.
      {{ tStatic('Ваш отзыв будет первым.') }}
    </div>
    <ReviewsLeaveBtn
      v-if="showLeaveButton"
      class="mt-10"
      :lpu-id="lpuId"
    />
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import ReviewsLeaveBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsLeaveBtn.vue'

defineProps<{
  lpuId: number
  lpuName: string
  showLeaveButton: boolean
}>()

const isMobile = useIsMobile()
</script>

<style scoped lang="scss">
.reviews-empty {
  &__text {
    max-width: 375px;
  }

  &__text--mobile {
    max-width: 254px;
  }
}
</style>
